export default {
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: 'https://www.shopruby.app/',
    site_name: 'Ruby',
  },
  twitter: {
    handle: '@shoprubyapp',
    site: '@shoprubyapp',
    cardType: 'summary_large_image',
  },
};